import React, { useState, useEffect } from 'react';
import { ListGroup, Badge, Spinner, Button } from 'react-bootstrap';
import { FaBirthdayCake, FaMedal, FaArrowRight } from 'react-icons/fa';
import { getReminders } from '../../services/firebase/reminderService';
import { useNavigate } from 'react-router-dom';
import './UpcomingReminders.css';

const UpcomingReminders = () => {
    const [reminders, setReminders] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchReminders();
    }, []);

    const fetchReminders = async () => {
        try {
            // Fetch reminders for next 7 days
            const response = await getReminders(7, null);
            setReminders(response.data || []);
        } catch (error) {
            console.error('Error fetching high priority reminders:', error);
        } finally {
            setLoading(false);
        }
    };

    const getDaysText = (daysUntil) => {
        if (daysUntil === 0) return 'Today';
        if (daysUntil === 1) return 'Tomorrow';
        return `${daysUntil} days`;
    };

    const getBadgeVariant = (daysUntil) => {
        if (daysUntil === 0) return 'danger';
        if (daysUntil === 1) return 'warning';
        return 'info';
    };

    if (loading) {
        return (
            <div className="text-center py-4">
                <Spinner animation="border" size="sm" variant="primary" />
            </div>
        );
    }

    return (
        <div className="upcoming-reminders-widget">
            <ListGroup variant="flush">
                {reminders.length > 0 ? (
                    reminders.slice(0, 5).map((reminder, index) => (
                        <ListGroup.Item key={index} className="border-0 py-3 reminder-item">
                            <div className="d-flex align-items-center">
                                <div className={`reminder-icon-circle me-3 ${reminder.type === 'birthday' ? 'birthday' : 'anniversary'}`}>
                                    {reminder.type === 'birthday' ? (
                                        <FaBirthdayCake size={18} />
                                    ) : (
                                        <FaMedal size={18} />
                                    )}
                                </div>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <h6 className="mb-1 reminder-name">{reminder.employeeName}</h6>
                                    <small className="text-muted">
                                        {reminder.type === 'birthday' ? 'Birthday' : `Work Anniversary (${reminder.years} years)`}
                                    </small>
                                </div>
                                <Badge bg={getBadgeVariant(reminder.daysUntil)} pill className="reminder-badge">
                                    {getDaysText(reminder.daysUntil)}
                                </Badge>
                            </div>
                        </ListGroup.Item>
                    ))
                ) : (
                    <ListGroup.Item className="text-center text-muted py-4 border-0">
                        <div className="empty-reminders">
                            <FaBirthdayCake className="empty-icon mb-2" />
                            <p className="mb-0">No upcoming reminders</p>
                        </div>
                    </ListGroup.Item>
                )}
            </ListGroup>

            {reminders.length > 0 && (
                <div className="text-center mt-3 pt-3 border-top">
                    <Button
                        variant="link"
                        className="view-all-btn"
                        onClick={() => navigate('/reminders')}
                    >
                        View All Reminders <FaArrowRight className="ms-2" />
                    </Button>
                </div>
            )}
        </div>
    );
};

export default UpcomingReminders;
